import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { DEFAULT_LOCALE, type AppLocale } from '../../i18n/locale'

const LOCALE_STORAGE_KEY = 'poolcontrol.locale'

function readStoredLocale(): AppLocale {
    if (typeof sessionStorage !== 'undefined') {
        const stored = sessionStorage.getItem(LOCALE_STORAGE_KEY)
        if (stored === 'en' || stored === 'ua') {
            return stored
        }
    }
    return DEFAULT_LOCALE
}

function persistLocale(locale: AppLocale): void {
    if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(LOCALE_STORAGE_KEY, locale)
    }
}

interface LocaleState {
    locale: AppLocale
}

const initialState: LocaleState = {
    locale: readStoredLocale(),
}

const localeSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLocale: (state, action: PayloadAction<AppLocale>) => {
            state.locale = action.payload
            persistLocale(action.payload)
        },
    },
})

export const { setLocale } = localeSlice.actions
export default localeSlice.reducer
